export default __webpack_public_path__ + "static/media/paper-edit-white.fde5ba0e.svg";